export const getAcoes = (state) => state.acoes.lista
export const getTotalAcoes = (state) => state.acoes.total
export const getIsCarregandoListaAcoes = (state) => state.acoes.isCarregandoLista
export const getAcaoSelecionada = (state) => state.acoes.selecionada
export const getIsCarregandoAcoes = (state) => state.acoes.isCarregandoAcoes
export const getIsSavingAcoes = (state) => state.acoes.isSaving
